export default __webpack_public_path__ + "static/media/font.ce1903c8.woff";